import { CONTENT_ALIGNMENT } from '@pperform/pp-constants/widgetConfigs';
import PpProgressIndicatorPreprintedReturn from '@pperform/pp-react-components/PpProgressIndicatorPreprintedReturn';
import PpProgressIndicatorReturn from '@pperform/pp-react-components/PpProgressIndicatorReturn';
import { ReturnShipment } from 'components/MerchantTrackingWidget/components/ReturnShipment/models/ReturnShipment.model';
import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import {
  constructReturnProgressIndicatorTheme,
  constructPreprintedReturnProgressIndicatorTheme,
} from 'utils/progressIndicator.utils';
import { Container } from './ProgressIndicator.styles';

interface ProgressIndicatorProps {
  shipment: ReturnShipment;
  type: 'full' | 'preprinted';
}

export const ProgressIndicator = ({
  shipment,
  type,
}: ProgressIndicatorProps): JSX.Element => {
  const { t } = useTranslation();
  const configs = usePTPConfigContext();
  const {
    trackingDetailsBox: { timelineAlignment },
  } = configs;
  const progressItemThemes: any =
    type === 'full'
      ? constructReturnProgressIndicatorTheme(configs)
      : constructPreprintedReturnProgressIndicatorTheme(configs);

  return (
    <Container>
      {type === 'full' ? (
        <PpProgressIndicatorReturn
          progressItemThemes={progressItemThemes}
          translation={t}
          mixedEvents={shipment.mixedEvents}
          returnTicket={shipment.returnTicket}
          alignEdgeItems={timelineAlignment === CONTENT_ALIGNMENT.LEFT}
        />
      ) : (
        <PpProgressIndicatorPreprintedReturn
          progressItemThemes={progressItemThemes}
          translation={t}
          parcelEvents={shipment.parcel.events}
          alignEdgeItems={timelineAlignment === CONTENT_ALIGNMENT.LEFT}
        />
      )}
    </Container>
  );
};
